import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import lifecycle from 'recompose/lifecycle'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'

import * as InboxSelectors from 'app/modules/inbox/selectors'
import * as InboxActions from 'app/modules/inbox/actions'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'

import PlaybookInboxSelect from './component'

const mapStateToProps = state => {
  const inboxes = InboxSelectors.inboxes(state)
  return {
    inboxes,
    isLoaded: InboxSelectors.isInboxListLoaded(state),
    isLoading: InboxSelectors.isInboxListLoading(state),
    inboxOptionsWithLabels: InboxSelectors.inboxOptionsWithLabels(state),
    selectedInboxId: PlaybookSelectors.playbookActionInboxId(state),
    defaultInbox: inboxes.first(),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchInboxList: InboxActions.fetchInboxList,
      setActionInboxId: PlaybookActions.setActionInboxId,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      if (this.props.inboxes.size === 0 && !this.props.isLoading) {
        this.props.actions.fetchInboxList()
      }
    },
  }),
  withHandlers({
    onSelectChange: ({ actions }) => option => {
      actions.setActionInboxId(option.value)
    },
  }),
  withProps(({ defaultInbox, selectedInboxId, inboxOptionsWithLabels }) => ({
    selectedInboxId: (!!selectedInboxId && selectedInboxId) || (!!defaultInbox && defaultInbox.id),
    inboxOptions: inboxOptionsWithLabels.toJS(),
  }))
)(PlaybookInboxSelect)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/PlaybookInboxSelect/index.js